<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Foreword by Ed Stetzer</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction</a></div>
<div class="SOM_part"><a href="#/p1">PART ONE: Eyes to See</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><span class="mev2">1</span> The First Urban Century</a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample"><span class="mev2">2</span> Cities: Headache or Opportunity?</span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><span class="mev2">3</span> What God Thinks of Cities</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART TWO: Eight Critical Responses</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><span class="mev2">4</span> Action 1: Pray Together</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><span class="mev2">5</span> Action 2: Exegete the City</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><span class="mev2">6</span> Action 3: Push Against Urban Poverty</span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample"><span class="mev2">7</span> Action 4: Reach Out to Diasporas</span></div>
<div class="SOM_chap"><span href="#/p2chap5" title="Link target outside of Sample"><span class="mev2">8</span> Action 5: Form Healthy Churches</span></div>
<div class="SOM_chap"><span href="#/p2chap6" title="Link target outside of Sample"><span class="mev2">9</span> Action 6: Confront Sinful Structures</span></div>
<div class="SOM_chap"><span href="#/p2chap7" title="Link target outside of Sample"><span class="mev2">10</span> Action 7: Address Real Human Pain Directly</span></div>
<div class="SOM_chap"><span href="#/p2chap8" title="Link target outside of Sample"><span class="mev2">11</span> Action 8: Embrace a Wider Vision</span></div>
<div class="SOM_appen SOM_appen1"><span href="#/appen4" title="Link target outside of Sample">Conclusion: Greater Things Are Still to Come</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Featured Ministries</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Also Available</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for Serving God in Today’s Cities</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Contributors</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?9ace245a